<script lang="ts">
	export let color: "green" | "teal" | "blue" | "gray" | "purple";
	export let opacity: 50 | 100 = 50;
</script>

<div
	class="h-2.5 w-full border"
	class:bg-blue-300={color === "blue"}
	class:bg-teal-300={color === "teal"}
	class:bg-green-300={color === "green"}
	class:bg-gray-400={color === "gray"}
	class:bg-purple-200={color === "purple"}
	class:opacity-50={opacity === 50}>
</div>
